module.exports = __webpack_public_path__ + "static/service-cs-salesmate-half-bf3696a665c24c847a1a68328e6c900b.jpg";